import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';

export const demoFunc = () => demoPage('Run status', 'Progress and error feedback for the current task.', html`
  <div class="statusDemo dees-demo-stack">
    <div class="dees-demo-label">Working</div>
    <dees-harness-status .status=${{ type: 'busy' as const }}></dees-harness-status>
    <div class="dees-demo-label">Progress details</div>
    <dees-harness-status
      .status=${{ type: 'busy' as const, message: 'Running tests — 3 of 12 files' }}
    ></dees-harness-status>
    <div class="dees-demo-label">Needs attention</div>
    <dees-harness-status
      .status=${{ type: 'error' as const, message: 'The model endpoint returned 429.' }}
    ></dees-harness-status>
    <div class="dees-demo-label">Ready</div>
    <dees-harness-status .status=${{ type: 'idle' as const }} showIdle></dees-harness-status>
  </div>
`);
